<template>
    <form-base v-on="$listeners" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase')
        },

        data() {
            return {
                contactForm: () => import('./ContactForm'),
                fields: [
                    { type: 'text', text: 'Email Address', value: 'emailAddress', rules: [v => !!v || 'Email Address is required', v => !(v && v.length > 320) || 'Email Address must be less than 320 characters'], isRequired: true, maxLength: 320 },
                    { type: 'checkbox', text: 'Is Email Confirmed', value: 'isEmailConfirmed', rules: [v => (v !== null && v !== '')] },
                    { type: 'checkbox', text: 'Is Inactive', value: 'isInactive', rules: [v => (v !== null && v !== '')] }
                ],
                apiMethod: 'Administrators',
                formTitle: 'Administrator',
            }
        },
    };
</script>
